import { Missing } from "@/admin/AdminTable.tsx";
import type { AdminHost } from "@warrenio/api-spec/spec.oats.gen";
import { sum } from "remeda";

function countCpus(cpulist: string) {
    return sum(
        cpulist.split(",").map((part) => {
            const trimmedPart = part.trim();
            if (!trimmedPart.includes("-")) {
                return 1;
            }

            const [start, end] = trimmedPart.split("-", 2).map(Number);
            return end - start + 1;
        }),
    );
}

export function NumaInfo({ item }: { item: AdminHost }) {
    const nodes = item.cpu_info?.nodes;
    if (nodes == null) {
        return <Missing />;
    }

    const minCpuCount = Math.min(...nodes.map((node) => countCpus(node.cpulist)));

    return (
        <>
            <div>{nodes?.length}</div>
            <div className="text-muted font-size-small">({minCpuCount})</div>
        </>
    );
}
